<template>
    <div class="my-article" v-loading="loading">
        <tab-header
            :tabList="articleTabList"
            :tabName="tabName"
            :isSelf="isSelf"
            @getTabName="getTabName"
            @getSortType="getSortType">
        </tab-header>
        <section class="article-content" v-loading="isLoading">
            <ul class="article-list" v-if="articleList.length">
                <li :class="[`data-item data-item${article.id}`, {'is-delete': article.status === 'Delete'}]" v-for="(article,index) in articleList" :key="index">
                    <div class="head">
                        <h3  @click="goArticleDetail(article)" class="question-name">{{article.title}}</h3>
                        <span v-if="article.status === 'Delete'" class="deleted">已删除</span>
                    </div>
                    <ul class="tags">
                        <li v-for="(i,index) in article.tags" :key="index" @click="goSearch(i)">
                            {{i.title}}
                        </li>
                    </ul>
                    <p class="question-desc" @click="goArticleDetail(article)">
                        {{article.descText}}
                    </p>
                    <p style="display: none;" :id="`virtual-dom-${article.id}`" class="question-desc img-hook"  v-html="article.afterhtmlData" ref="descHook"></p>
                    <div class="comment-bottom-content" v-if="article.status !== 'Delete'">
                        <div class="answer-list">
                            <p class="answer-text great" :class="{'active': article.is_vote_up}" @click="handleVoteToggle(article)">
                                <i class="smart-img"></i>
                                <span>{{article.no_of_vote_up}}<i class="text">赞</i></span>
                            </p>
                            <p class="answer-text view">
                                <i class="smart-img view-icon"></i>
                                <span>{{article.no_of_views | transformUnit}}<i class="text">阅读</i></span>
                            </p>
                            <p class="answer-text comment" @click="goArticleDetail(article, true)">
                                <i class="smart-img"></i>
                                <span>{{article.no_of_comment}}<i class="text">评论</i></span>
                            </p>
                            <el-tooltip
                                effect="dark"
                                :content="article.is_liked ? '取消收藏' : '收藏'"
                                placement="top">
                                <p class="answer-text favorite" :class="{'active': article.is_liked}" @click="handleFavoriteToggle(article)">
                                    <i class="smart-img"></i>
                                    <span>{{article.no_of_likes}}<i class="text">收藏</i></span>
                                </p>
                            </el-tooltip>
                            <template v-if="isSelf && article.created_by.user_id === userId">
                                <p class="answer-text edit" @click="editeArticle(article.id)">
                                    <i class="smart-img"></i>
                                    <span>编辑</span>
                                </p>
                                <p class="answer-text delete" @click="deleteArticle(article.id)">
                                    <i class="smart-img"></i>
                                    <span>删除</span>
                                </p>
                            </template>
                        </div>
                        <p class="topic-people">{{article.created_by.nick_name}} 于 {{article.created_on}}发布</p>
                    </div>
                </li>
            </ul>
            <!-- 无数据 -->
            <div class="content-empty" v-show="!articleList.length && !isLoading">
                <img src="../../images/personal_center/data-null.png" alt="" />
                <p>暂无数据</p>
            </div>
            <!-- 滚动加载loading -->
            <div class="load-more" v-if="isMoreLoading || articleList.length">
                <img v-if="isMoreLoading" alt="loadding" src="../../images/common/loading_2_24x24.gif">
                <span v-else>{{ totalPage === curPage ? '没有更多内容了' : '显示更多' }}</span>
            </div>
        </section>
        
    </div>
</template>

<script>
import tabHeader from './tabHeader.vue'
import mavonEditor from 'mavon-editor';
import personalCenter from '@/mixins/personalCenter.js'
export default {
    components: {
        tabHeader
    },
    mixins: [ personalCenter ],
    data () {
        return {
            articleTabList: [
                {
                    label: '的文章',
                    name: 'my_article',
                    count: 0
                },
                {
                    label: '收藏的文章',
                    name: 'favorites_article',
                    count: 0
                }
            ],
            curTabName: '',
            tabName: 'my_article',
            articleList: [],
            sortType: '-created_on',
        }
    },
    watch: {
        statisticsInfo: {
            handler (val) {
                if (!val) return
                // 设置默认条数
                this.articleTabList.forEach(item => {
                    const type = item.name === 'my_article'
                        ? 'article_num'
                        : 'like_num'
                    item.count = this.statisticsInfo[type]
                })
            },
            immediate: true
        }
    },
    methods: {
        // 切换tab
        getTabName (name) {
            this.tabName = name || 'my_article'
            this.curPage = 1
            this.getArticleList()
        },
        // 我的文章列表
        async getArticleList (tabName = this.tabName, isMore) {
            try {
                if (isMore) {
                    this.isMoreLoading = true
                } else {
                    this.isLoading = !this.loading
                }
                const params = {
                    page: this.curPage,
                    page_size: 10,
                    board: 'article',
                    ordering: this.sortType
                }
                if (tabName === 'my_article') {
                    params.status = 'Published'
                    params.user = this.userId
                } else {
                    params.liked_user = this.userId
                }
                const url = 'forum/topics/'
                await axios.get(myUrl + url, {
                    params
                }).then(res => {
                    const resp = res.data
                    if (!resp.result) return
                    // 设置tab关注数
                    const tab = this.articleTabList.find(item => item.name === tabName)
                    tab.count = resp.data.count

                    this.totalPage = Math.ceil(resp.data.count / 10)
                    this.isPageOver = this.curPage >= this.totalPage
                    const articleList = resp.data.results.map(element => {
                        // 描述
                        this.$set(element, 'afterhtmlData', '')
                        // 显示的文本
                        this.$set(element, 'descText', '')

                        if (element.format !== 'Markdown') {
                            element.afterhtmlData = filterXSS(element.description)
                        } else {
                            const data = mavonEditor.markdownIt.render(element.description)
                            element.afterhtmlData = filterXSS(data)
                        }

                        setTimeout(() => {
                            const dom = document.querySelector(`#virtual-dom-${element.id}`)
                            if (dom) {
                                element.descText = dom.textContent
                            }
                        }, 0)
                        return element
                    })
                    if (isMore) {
                        this.articleList.push(...articleList)
                    } else {
                        this.articleList = articleList
                    }
                    this.curTabName = this.tabName
                })
            } catch (error) {
                console.warn(error)
            } finally {
                this.loading = false
                this.isLoading = false
                this.isMoreLoading = false
            }
        },
        // 点赞&取消点赞
        handleVoteToggle (article) {
            try {
                let params = {
                    topic_id: article.id,
                    vote: article.is_vote_up ? null : true
                }
                axios.post(myUrl + 'forum/usertopic/', params).then((res) => {
                    if (res.data.result) {
                        article.is_vote_up = article.is_vote_up ? null : true
                        let msg = ''
                        if (article.is_vote_up) {
                            article.no_of_vote_up += 1
                            msg = '点赞成功'
                        } else {
                            article.no_of_vote_up -= 1
                            msg = '取消点赞成功'
                        }
                        this.$message({
                            message: msg,
                            type: 'success'
                        })
                    }
                })
            } catch (error) {
                console.warn(error);
            }
        },
        // 前往搜索页
        goSearch (tag) {
            const selectTag = encodeURIComponent(tag.title) || undefined
            let routeData = this.$router.resolve({
                path: '/s-mart/community/search',
                query: {
                    selectTag
                }
            })
            window.open(routeData.href, '_blank')
        },
        // 前往文章详情
        goArticleDetail (item, isComment) {
            if (item.status === 'Delete') return
            if (isComment) {
                localStorage.setItem('commentWrapper', true)
            }
            let routeData = this.$router.resolve({
                name: 'Question',
                params: {
                    wid: item.id
                },
                query: {
                    type: 'article'
                }
            })
            window.open(routeData.href, '_blank')
        },
        // 关注&取消关注
        handleFavoriteToggle (article) {
            try {
                let params = {
                    topic_id: article.id,
                    is_like: !article.is_liked
                }
                axios.post(myUrl + 'forum/usertopic/', params).then((res) => {
                    if (res.data.result) {
                        article.is_liked = !article.is_liked
                        const curTab = this.articleTabList.find(item => item.name === 'favorites_article')
                        let msg = ''
                        if (article.is_liked) {
                            article.no_of_likes += 1
                            curTab.count++
                            msg = '关注成功'
                        } else {
                            article.no_of_likes -= 1
                            curTab.count--
                            msg = '取消关注成功'
                        }
                        this.$message({
                            message: msg,
                            type: 'success'
                        })
                    }
                })
            } catch (error) {
                console.warn(error)
            }
        },
        // 编辑
        editeArticle (articleId) {
            const routeData = this.$router.resolve({
                path: `/s-mart/community/ask/${articleId}/`
            })
            window.open(routeData.href, '_blank')
        },
        // 删除
        deleteArticle (articleId) {
            this.$bkInfo({
                title: '确认要删除？',
                confirmFn: () => {
                    this.deleteQuestion(articleId);
                }
            })
        },
        // 删除回调
        deleteQuestion (articleId) {
            try {
                axios.delete(myUrl + `forum/topics/${articleId}/`).then(res => {
                    if (res.data.result) {
                        const index = this.articleList.find(article => article.id === articleId)
                        this.articleList.splice(index, 1)
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        })
                    }
                })
            } catch (error) {
                console.warn(error)
            }
        },
        // 切换排序类型
        getSortType (sort) {
            this.sortType = sort
            this.curPage = 1
            this.getArticleList()
        },
        // 滚动加载
        handleScroll () {
            // 滚动加载
            this.scrollLoading(this.getArticleList)
        }
    }
}
</script>

<style lang="scss">
    .my-article {
        .el-loading-mask {
            .el-loading-spinner {
                top: 250px !important;
            }
        }
    }
</style>

<style lang="scss" scoped>
    .my-article {
        width: 1200px;
        margin: 0 auto 17px;
        background: #fff;
        padding-bottom: 20px;
        .article-content {
            min-height: 320px;
            padding: 30px 16px 0;
        }
        .data-item {
            padding: 21px 0 17px;
            border-bottom: 1px solid #f0f1f5;
            position: relative;
            &:first-child {
                padding-top: 0;
            }
            .head{
                display: flex;
                align-items: flex-start;
                margin-bottom: 15px;
                .question-name{
                    word-break: break-all;
                    cursor: pointer;
                    font-size: 16px;
                    line-height: 21px;
                    color: #313238;
                    font-weight: bold;
                    .mark-red{
                        color: #ff5858;
                    }
                    &:hover {
                        color: #3a84ff;
                    }
                }
                .deleted {
                    background: #feebea;
                    color: #ff5656;
                    margin-left: 3px;
                    line-height: 15px;
                    font-size: 12px;
                    border-radius: 2px;
                    padding: 3px 7px;
                }
            }
            .tags {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                >li {
                    margin: 0 10px 10px 0;
                    padding: 2px 10px;
                    border-radius: 11px;
                    border: 1px solid #e3e8f2;
                    background: #fafafc;
                    font-size: 12px;
                    color: #888991;
                    text-align: center;
                    line-height: 16px;
                    &:hover {
                        cursor: pointer;
                        background: #eaebf0;
                    }
                }
            }
            .question-desc {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
                cursor: pointer;
                word-break: break-all;
                &:hover {
                    color: #313238;
                }
            }
            .question-img {
                flex-shrink: 0;
                margin-left: 19px;
            }
            .comment-bottom-content {
                margin-top: 16px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                color: #63656e;
                .answer-list {
                    font-size: 0;
                    display: flex;
                    align-items: center;
                    .answer-text {
                        display: flex;
                        align-items: center;
                        margin-right: 40px;
                        padding-left: 3px;
                        line-height: 14px;
                        font-size: 12px;
                        .smart-img {
                            height: 16px;
                            width: 16px;
                            margin-right: 5px;
                            display: inline-block;
                            margin-right: 5px;
                            &::before, &::after {
                                content: '';
                                height: 16px;
                                width: 16px;
                                position: absolute;
                                z-index: 1;
                                display: none;
                            }
                        }
                        &.view {
                            .view-icon {
                                background: url('../../images/community/eye-open.png');
                                background-size: 100% 100%;
                            }
                        }
                        &.great {
                            .smart-img {
                                background: url('../../images/community/great3.png');
                                background-size: 100% 100%;
                                &::before {
                                    background: url('../../images/community/great4.png');
                                    background-size: 100% 100%;
                                }
                                &::after {
                                    background: url('../../images/community/great2.png');
                                    background-size: 100% 100%;
                                }
                            }
                        }
                        &.comment {
                            .smart-img {
                                background: url('../../images/community/comment3.png');
                                background-size: 100% 100%;
                                &::before {
                                    background: url('../../images/community/comment4.png');
                                    background-size: 100% 100%;
                                }
                                &::after {
                                    background: url('../../images/community/comment5.png');
                                    background-size: 100% 100%;
                                }
                            }
                        }
                        &.favorite {
                            .smart-img {
                                background: url('../../images/community/favorite3.png');
                                background-size: 100% 100%;
                                &::before {
                                    background: url('../../images/community/favorite4.png');
                                    background-size: 100% 100%;
                                }
                                &::after {
                                    background: url('../../images/community/favorite2.png');
                                    background-size: 100% 100%;
                                }
                            }
                        }
                        &.edit {
                            .smart-img {
                                background: url('../../images/personal_center/edit.png');
                                background-size: 100% 100%;
                                &::before {
                                    background: url('../../images/personal_center/edit2.png');
                                    background-size: 100% 100%;
                                }
                            }
                        }
                        &.delete {
                            .smart-img {
                                background: url('../../images/personal_center/delete.png');
                                background-size: 100% 100%;
                            }
                            &:hover .smart-img {
                                background: url('../../images/community/delete2.png');
                                background-size: 100% 100%;
                            }
                        }
                        &:hover {
                            &:not(.view) {
                                cursor: pointer;
                                color: #3a84ff;
                            }
                            .smart-img::before {
                                display: block;
                                z-index: 3;
                            }
                        }
                        &.active {
                            color: #3a84ff;
                            .smart-img {
                                background: none;
                                &::before {
                                    display: none !important;
                                }
                                &::after {
                                    display: block;
                                    z-index: 3;
                                }
                            }
                        }
                        .text {
                            margin-left: 2px;
                            font-style: initial;
                        }
                    }
                }
                .topic-people {
                    font-size: 12px;
                    line-height:19px;
                }
            }
            &.is-delete {
                margin: 10px 0;
                .question-name, .question-desc {
                    color: #c4c6cc;
                    cursor: not-allowed;
                    &:hover {
                        color: #c4c6cc;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// my_article.vue?7e8cd178